import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Input from '../../general/Input/Input';
import Button from '../../general/Button/Button';
import { resetPassword } from '../../../store/actions/userActions';
import './LoginRegisterReset.css';
import { validateEmail } from '../../../utils/ValidationLoginRegisterReset';
import Alert from '../../intern/Alert/Alert';

const ResetPassword = () => {
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });
    const [loading, setLoading] = useState(false)


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validação do e-mail
        const emailError = validateEmail(email);
        if (emailError) {
            setError(emailError);
            return;
        }

        setError('');
        setLoading(true);


        try {
            // Chama ação Redux e aguarda retorno
            await dispatch(resetPassword({ email }));

            // Sucesso
            setAlert({
                visible: true,
                type: 'adicionar',
                message: 'Se o e-mail estiver cadastrado, você receberá um link de recuperação.'
            });

            setEmail('');

        } catch (err) {
            // Erro do backend
            setAlert({
                visible: true,
                type: 'erro',
                message: err.message || 'Erro ao enviar o e-mail. Tente novamente.'
            });
        } finally {
            setLoading(false); // termina loading
        }
    };


    return (
        <div className="containerMain">
            <div className="formContainer">

                <div className="textCenter">
                    <h1 className="heading">Recuperação de senha</h1>
                    <p className="subheading">Digite seu e-mail para receber um link de recuperação.</p>
                </div>

                <Helmet>
                    <title>Reset Password</title>
                </Helmet>

                <form onSubmit={handleSubmit}>
                    <div className="inputGroup">
                        <Input
                            type="email"
                            placeholder="example@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={error}
                        />
                        {error && <p className="errorText">{error}</p>}
                    </div>

                    <Button
                        type="submit"
                        className='btn-margin btn-primary'
                        variant="primary"
                        fullWidth
                        disabled={loading} >
                        {loading ? 'Enviando...' : 'Enviar e-mail'}
                    </Button>

                    <hr className="divider" />

                    <div className="textCenter">
                        <p className="text-gray-600">
                            Lembrou a senha?
                            <Link to="/" className="linkLogin">Voltar para o login</Link>
                        </p>
                    </div>
                </form>


                {alert.visible && (
                    <Alert
                        type={alert.type}
                        message={alert.message}
                        onClose={() => setAlert({ visible: false, type: '', message: '' })}
                    />
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
